import { AddressType, TitleId } from '@domgen/dgx-fe-common';
import { PersonalDetailsFormValue } from '../../models/personal-details/personal-details-form-value.type';

export const mockPersonalDetailsFormValue: PersonalDetailsFormValue = {
  addProtectionPolicy: false,
  address: {
    id: 'GB|RM|B|445899',
    addressLine1: '123 Fairwater House',
    addressLine2: '3 Bonnet Street',
    addressLine3: 'London',
    addressLine4: '',
    postalCode: 'E16 2SZ',
    countryCode: 'GBR',
    countryIso2: 'GB',
    countryIso3: 'GBR',
    countryIsoNumber: 826,
    countryName: 'Great Britain',
    type: AddressType.Residential,
    isOverrideAddress: true,
  },
  emailAddress: 'bob@ross.com',
  firstName: 'Bob',
  groupMarketingPreferences: {
    groupMarketingConsent: null,
    groupMarketingPreferences: {},
  },
  lastName: 'Ross',
  marketingPreferenceEmail: true,
  marketingPreferencePost: true,
  marketingPreferenceTelephone: true,
  privacyPolicy: true,
  telephoneNumber: '0123456789',
  titleId: TitleId.Mr,
};
